<template>
  <div class="workbench-contract-container">
    <div class="content">
      <div class="bench">
        <div style="display: flex;align-items: center;justify-content: space-between;">
          <div style="display: flex;">
            <img class="avatar" :src="avatar" alt=""/>
            <div class="over-view">
              <div>
                <p class="value">{{ num.total_covenant|numberFormat }}</p>
                <p class="title">所有合同 </p>
              </div>
              <div>
                <p class="value">{{ num.total_order|numberFormat }}</p>
                <p class="title">所有订单 </p>
              </div>
              <div>
                <p class="value">{{ num.part_wait_order|numberFormat }}</p>
                <p class="title">待签订单 </p>
              </div>
              <div>
                <p class="value">{{ num.part_done_order|numberFormat }}</p>
                <p class="title">已签合同订单 </p>
              </div>
            </div>
          </div>
          <div class="tip">
            <p>新建合同，上传有效附件</p>
            <p>有合同的订单即视订单为有效订单，待签订单为无效订单</p>
            <p>请认真核对合同与订单是否一致</p>
          </div>
        </div>
        <div class="line"/>
      </div>
      <el-tabs>
        <el-tab-pane label="所有合同">
          <contracts/>
        </el-tab-pane>
        <el-tab-pane label="待签订单">
          <orders-wait/>
        </el-tab-pane>
        <el-tab-pane label="已签合同订单">
          <orders-done/>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Contracts from "@/views/workbench/Contract/contracts.vue";
import OrdersWait from "@/views/workbench/Contract/ordersWait.vue";
import OrdersDone from "@/views/workbench/Contract/ordersDone.vue";
import {orderCovenantSummation} from "@/api/orderCovenant";

const {avatar} = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).value : {id: -1}

export default {
  name: "WorkbenchContract",
  components: {Contracts, OrdersWait, OrdersDone},
  provide() {
    return {refreshSummation: this.getData}
  },
  data() {
    return {
      avatar,
      num: {
        "total_covenant": 0,
        "total_order": 0,
        "part_wait_order": 0,
        "part_done_order": 0
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const {model} = await orderCovenantSummation()
      this.num = model
    }
  }
}
</script>

<style lang="scss">
.workbench-contract-container {
  font-family: FjallaOne-Regular, sans-serif !important;
  padding: 24px;
  background: #f3f3f3;
  height: calc(100% - 48px);

  p {
    margin-block-start: 0;
    margin-block-end: 0;
  }

  .content {
    background: #FFFFFF;
    height: 100%;
    border-radius: 6px;
    padding: 0 30px;
  }

  .el-tabs {
    height: calc(100% - 146px);

    .el-tabs__nav-wrap::after {
      display: none;
    }

    .el-tabs__content {
      height: calc(100% - 60px);
    }

    .el-tab-pane {
      height: 100%;
    }
  }

  .form-item-customer {
    .el-form-item__content {
      width: 300px;
    }
  }

  .bench {
    background-image: url("../../../assets/images/popularize-bg.png");
    background-size: 30% 100%;
    background-repeat: no-repeat, no-repeat, no-repeat;
    padding-top: 20px;

    .avatar {
      width: 90px;
      height: 90px;
      line-height: 90px;
      font-size: 45px;
      margin-right: 10px;
      cursor: pointer;
      flex-shrink: 0;
      border-radius: 50%;
    }

    .over-view {
      display: flex;
      align-items: center;
      padding: 20px;

      div {
        border-right: 1px solid #E9EFF6;
        padding: 0 30px;
      }

      div:last-child {
        border-right: unset;
      }

      .value {
        font-size: 26px;
        font-weight: 600;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-bottom: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .title {
        font-size: 14px;
        color: #8a8e99;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-bottom: 0;
      }
    }

    .tip {
      font-size: 12px;
      color: #898e99;

      p:before {
        content: "* ";
        color: #ff3176;
      }
    }

    .line {
      border-bottom: 1px solid #f3f3f3;
    }
  }
}
</style>
